// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"8a10a5e1","363":"76ec7ce9","433":"e336a0be","453":"89f79772","525":"39632969","819":"84b86a6e","967":"809a6f4e"}[chunkId] + ".chunk.js";
};